import axios from 'axios'

const loadFlights = async ({ vendor_list, irish }) => {
  try {
    const res = await axios
      .post(`${process.env.VUE_APP_VT_API_URL}/vt-api/viewtrail/flight-info`, { vendor_list, irish })
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

const fetchEarlyTicketBlacklist = async () => {
  try {
    const res = await axios.get(
      `${process.env.VUE_APP_VT_API_URL}/vt-api/viewtrail/early-ticket-blacklist`,
    )
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}

export { loadFlights, fetchEarlyTicketBlacklist }
